import { absoluteUrl } from '@/lib/seo/canonical-url';
import { resolveOgImages } from '@/lib/seo/og-image';
import { NextSeo, NextSeoProps } from 'next-seo';

interface SeoProps extends NextSeoProps {
  url?: string;
  images?: any[] | null;
}

const Seo = ({ title, description, images, url, twitter, ...props }: SeoProps) => {
  const canonicalUrl =
    url != null && String(url).trim() !== '' ? absoluteUrl(url) : undefined;
  const ogImages = resolveOgImages(images, title || 'Qualidoc');

  return (
    <NextSeo
      {...(title ? { title } : {})}
      {...(description ? { description } : {})}
      {...(canonicalUrl ? { canonical: canonicalUrl } : {})}
      openGraph={{
        type: 'website',
        locale: 'pt_BR',
        ...(canonicalUrl && {
          url: canonicalUrl,
        }),
        ...(title ? { title } : {}),
        ...(description ? { description } : {}),
        images: ogImages,
      }}
      twitter={{
        cardType: 'summary_large_image',
        ...twitter,
      }}
      {...props}
    />
  );
};

export default Seo;
